import { z } from "zod";

const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

export const resetPasswordFormSchema = z
    .object({
        email: z
            .string()
            .nonempty("Email is required.")
            .email("Invalid email address.").trim(),

        newPassword: z
            .string()
            .nonempty("Password is required")
            .min(8, "Password must be at least 8 characters long.")
            .regex(
                strongPasswordRegex,
                "Password must include at least one uppercase letter, one lowercase letter, one number, and one special character."
            ),
        confirmPassword: z
            .string()
            .nonempty("Please confirm your password."),
        token: z.string().nonempty("Reset token is required"),
    })
    .refine((data) => data.newPassword === data.confirmPassword, {
        path: ["confirmPassword"],
        message: "Passwords do not match.",
    });

export type ResetPasswordFormSchema = z.infer<typeof resetPasswordFormSchema>;
